import { css } from 'linaria';
import { styled } from 'linaria/react';
import { media } from '../../../../../../../../../media';

export const TopCategory = styled.div<{ isVisible: boolean }>`
	display: ${({ isVisible }) => (isVisible ? 'block' : 'none')};
	margin-top: 70px;

	&:first-child {
		margin-top: 30px;
		${media.tablet} {
			margin-top: 16px;
		}
	}
	${media.tablet} {
		margin-top: 40px;
	}
`;

export const TopCategoryTitle = css`
	${media.tablet} {
		font-size: 22px !important;
		line-height: 28px !important;
	}
`;

// !important ^ чтобы перебить стили фронтона
